import React, {useState} from 'react'
import useStyles from './utils/comparatoreStyle';

import { Box, CardContent, Collapse, Button } from '@mui/material';

import __t from "../../../lib/traduzioni";
import useBSSLogger from '../../../hooks/useBSSLogger';
import { svuotaServizi } from './utils/funzioni';
import HeaderAddizionali from './HeaderAddizionali';
import ErroriAddizionali from './ErroriAddizionali';
import FormAddizionaliPrezzo from './FormAddizionaliPrezzo';
import { useRef } from 'react';
import { useEffect } from 'react';
import StatoComparatoreContext from './contexts/StatoComparatore';
import { useContext } from 'react';

const {logger} = useBSSLogger();


const AddizionaliPrezzo = ({listaaddizionali, preventivo, erroriRicalcolo, setErroriRicalcolo, eseguiRicalcolo}) => {
    
    
    const {expanded, setExpanded, methods, addizionaliById, categoriaById} = useContext(StatoComparatoreContext)

    const classes = useStyles();  
    const {prodotto} = preventivo.price.associazione


    return (
        <>
            <div className={classes.additionalData}>
                <HeaderAddizionali {...{
                    listaaddizionali,
                    preventivo,
                }}  />             
                <Collapse in={expanded[preventivo.price.id]} timeout="auto">                                
                    <CardContent sx={{
                        paddingTop: 0,                                                 
                        '&:last-child': {
                            paddingBottom: 0
                        }
                    }}>
                        
                        <ErroriAddizionali {...{
                            erroriRicalcolo,
                            setErroriRicalcolo,
                            preventivo,                            
                        }}  />

                        <Box>
                            <Box width={1}>
                                <Box display={"flex"} flexDirection={"row-reverse"}>
                                    <Button type={"button"} onClick={e => svuotaServizi(preventivo, null, methods, eseguiRicalcolo)}>
                                        {__t("svuota")} {__t("servizi")} {preventivo.description}
                                    </Button>
                                </Box>
                            </Box>

                            <FormAddizionaliPrezzo {...{
                                listaaddizionali,
                                prodotto,
                                eseguiRicalcolo,
                                preventivo
                            }} />                           
                        </Box>
                    </CardContent>
                    
                </Collapse>
            </div>
        </>
    )
}

export default AddizionaliPrezzo